import ZoomControl from "ol/control/Zoom";
import { useContext, useEffect, useMemo } from "react";
import MapContext from "./MapContext";

function MapZoomControl() {
  const { map } = useContext(MapContext);

  const zoomControl = useMemo(() => {
    return new ZoomControl();
  }, []);

  useEffect(() => {
    if (zoomControl) map?.addControl(zoomControl);
    return () => {
      if (zoomControl) map?.removeControl(zoomControl);
    };
  }, [map, zoomControl]);
  return null;
}

export default MapZoomControl;
